import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {GlobalConstants} from "../../../common/global-constants";
import {ConfigurationService} from "../../../services/configuration.service";
import {AuthenticationService} from "../../../services/authentication.service";
import {CommonUtils} from "../../../utils/common.utils";

@Component({
  selector: 'app-configure-transit-time-requests',
  templateUrl: './configure-transit-time-requests.component.html',
  styleUrls: ['./configure-transit-time-requests.component.scss']
})
export class ConfigureTransitTimeRequestsComponent implements OnInit {
  @Input('pageData') pageData;

  updateTransitTimeTypeUrl: string = GlobalConstants.UPDATE_TRANSIT_TIME_TYPE_ENDPOINT;
  configureTransitTimeForm: FormGroup;

  transitTimeConfigurations: any[] = [];
  fromCountryCodeOptions: any[];
  transitTimeConfigurationRecords: any[];

  loading = false;
  firstLoad = true;

  carrier_provided = GlobalConstants.CARRIER_PROVIDED_KEYWORD;
  computed = GlobalConstants.COMPUTED_KEYWORD;
  ml_optimized = GlobalConstants.ML_OPTIMIZED_KEYWORD;
  precision_optimized = GlobalConstants.PRECISION_OPTIMIZED_KEYWORD;
  HYBRID_TRANSIT_TIME_TYPE = GlobalConstants.HYBRID_TRANSIT_TIME_TYPE;

  countryCodes: any;
  items: any;

  currentWorkingRecord: any;

  help_messages: any = this.dataService.help_messages;

  user = {};

  get passportEnabledShipmethods(){
    return this.dataService.passportEnabledShipmethods;
  }

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('DataPathUtils') private dataPathUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService) {
  }

  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.configureTransitTimeForm = this.formBuilder.group({
      fromCountryCode: ['', Validators.required],
      businessUseCase: ['', Validators.required],

    });
    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.items = this.commonUtils.getItemsBasedOnArc();
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};
    this.configureTransitTimeForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.transitTimeConfigurations = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.transitTimeConfigurationRecords = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
      console.log(data)
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.transitTimeConfigurations = [];
  }

  public async changeTransitTimeType(row, key) {
    if (row[GlobalConstants.TRANSIT_TIME_TYPE] != key) {
      this.loading = true;

      let requestBody = JSON.parse(JSON.stringify(row));
      requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
      requestBody[GlobalConstants.TRANSIT_TIME_TYPE] = key;
      requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(requestBody);
      if (hasPermission === false){
        this.loading = false;
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }

      this.requestsService.put(this.updateTransitTimeTypeUrl, requestBody).subscribe(data => {
        this.loading = false;
        this.toastrService.success("Request submitted, transit time type will be updated shortly. Please reload and check after sometime", GlobalConstants.TITLE_SUCCESS)
      }, error => {
        this.loading = false;
        this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
      });
    } else {
      this.toastrService.error("Already set to " + key, GlobalConstants.TITLE_ERROR);
    }
  }

  public isPassportEnabledShipmethod(row){
    const componentKeyValue = row?.componentKeyValue;
    return componentKeyValue.split(":").some(value=>this.passportEnabledShipmethods[value])
  }

  render() {
    this.firstLoad = false;
    let requestBody = JSON.parse(JSON.stringify(this.configureTransitTimeForm.value));
    requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    this.transitTimeConfigurations = this.transitTimeConfigurationRecords.filter(record => record.businessUnit === requestBody[GlobalConstants.BUSINESS_UNIT] && record.fromCountryCode === requestBody[GlobalConstants.FROM_COUNTRY_CODE] && record.componentKeyValue != null);
  }


}
